import { ModalFooterButton } from '@/components/Modal'
import { useTexts } from '../../../useTexts'
import { useController } from '../../../hooks/useController'

export function ButtonApplyChangesAndDelete() {
  const texts = useTexts()
  const {
    updateData,
    data: { inputError },
  } = useController()

  return (
    <ModalFooterButton
      testid="modal-tertiary-button"
      title={texts.buttonApplyChangesAndDelete}
      onClick={() => updateData({ model: 'delete' })}
      disabled={!!inputError.hasError}
    >
      {texts.buttonApplyChangesAndDelete}
    </ModalFooterButton>
  )
}
